var _clipPath, _clipPath2, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVndMsExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3470.32,-1703.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837,412.889L837,511.889L909,511.889L909,439.889L882,412.889L837,412.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837,511.889L837,412.889L909,412.889L909,511.889L837,511.889Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882,412.889L909,439.889L909,511.889L837,511.889L837,412.889L882,412.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(82,130,39)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.745,436.889L878.745,438.923C880.529,439.097 881.665,439.309 882.15,439.561C882.635,439.813 882.878,440.191 882.878,440.695C882.878,441.13 882.457,441.943 881.617,443.131C880.774,444.321 878.715,446.868 875.435,450.775C874.323,449.074 873.327,447.553 872.449,446.218C871.572,444.88 870.923,443.865 870.506,443.171C870.018,442.372 869.693,441.786 869.529,441.413C869.362,441.039 869.28,440.73 869.28,440.488C869.28,440.001 869.701,439.636 870.545,439.391C871.388,439.149 872.688,438.993 874.444,438.923L874.444,436.889L851.84,436.889L851.84,438.923C852.623,438.975 853.294,439.065 853.852,439.196C854.408,439.327 854.913,439.488 855.366,439.678C856.272,440.027 857.138,440.601 857.965,441.399C858.791,442.198 859.484,442.999 860.039,443.798C861.151,445.396 862.504,447.335 864.102,449.612C865.698,451.888 867.296,454.233 868.893,456.65C867.209,458.614 865.601,460.466 864.073,462.203C862.545,463.941 861.172,465.497 859.957,466.87C859.122,467.827 858.313,468.665 857.529,469.386C856.746,470.108 855.85,470.702 854.842,471.173C854.406,471.365 853.968,471.51 853.523,471.614C853.08,471.719 852.484,471.798 851.737,471.851L851.737,473.883L866.101,473.883L866.101,471.851C865.289,471.781 864.588,471.684 863.997,471.564C863.406,471.442 862.989,471.312 862.746,471.173C862.416,471.015 862.212,470.854 862.133,470.691C862.055,470.524 862.016,470.322 862.016,470.077C862.016,469.626 862.507,468.704 863.489,467.314C864.471,465.923 866.785,463.117 870.432,458.894C871.528,460.529 872.584,462.115 873.6,463.652C874.617,465.19 875.43,466.471 876.038,467.497C876.437,468.14 876.751,468.708 876.976,469.204C877.202,469.698 877.315,470.06 877.315,470.286C877.315,470.702 877.003,471.038 876.376,471.29C875.75,471.542 874.358,471.727 872.201,471.851L872.201,473.883L894.752,473.883L894.752,471.851C893.866,471.798 893.154,471.702 892.615,471.564C892.076,471.425 891.598,471.276 891.181,471.12C890.294,470.772 889.438,470.195 888.612,469.386C887.787,468.577 887.113,467.775 886.592,466.975C885.253,465.101 883.836,463.095 882.341,460.96C880.845,458.825 879.046,456.177 876.942,453.016C878.647,451.067 880.085,449.417 881.258,448.067C882.433,446.719 883.663,445.33 884.949,443.902C885.819,442.946 886.618,442.112 887.348,441.399C888.078,440.686 888.981,440.087 890.06,439.601C890.615,439.375 891.106,439.21 891.532,439.104C891.958,439.001 892.501,438.94 893.162,438.923L893.162,436.889L878.745,436.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.291,455.437L872.501,416.228L912.454,456.181L873.244,495.39L833.291,455.437Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882,439.889L909,439.889L882,412.889L882,439.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M868.5,426.389L882,412.889L909,439.889L895.5,453.389L868.5,426.389Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882,412.889L909,439.889L882,439.889L882,412.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "bevel",
      stroke: "rgb(82,130,39)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "845px",
    y: "503.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "white"
    }
  }, "XLS"))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-98.9995,98.9995,-4.3e-06,873,511.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(81,133,42)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(133,196,64)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(39.2092,-39.2092,39.2092,39.2092,853.269,475.415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(97,149,47)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(36,77,10)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.5003,-13.5003,13.5003,13.5003,882,439.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(242,246,213)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    style: {
      stopColor: "rgb(203,219,167)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(97,153,50)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVndMsExcel);
export default __webpack_public_path__ + "static/media/vnd-ms-excel.fc1eb4d8dd1b37744887ab2bb6cfa281.svg";
export { ForwardRef as ReactComponent };